/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'dropshipment': {
    width: 16,
    height: 16,
    viewBox: '0 0 100 96.9',
    data: '<path pid="0" d="M43.8 65l38.4 14.1L100 0 43.8 65zM0 50l31.2 10.6L100 0 0 50zm43.8 46.9l18.1-18.4-18.1-6.6v25z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/dist/icons/dropshipment.js